document.addEventListener('submit', async (e) => {
  const form = e.target.closest('[data-restock-form]');
  if (!form) return;

  e.preventDefault();

  const emailInput = form.querySelector('input[type="email"]');
  const variantId = form.dataset.variantId;
  const publicKey = form.dataset.klaviyoPublicKey;
  const submitBtn = form.querySelector('button[type="submit"]');
  const successEl = form.parentElement.querySelector('[data-restock-success]');
  const errorEl = form.querySelector('[data-restock-error]');

  if (!emailInput.value || !variantId || !publicKey) return;

  submitBtn.disabled = true;
  if (errorEl) errorEl.hidden = true;

  try {
    const res = await fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${publicKey}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2024-10-15',
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: emailInput.value },
                },
              },
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${variantId}`,
                },
              },
            },
          },
        }),
      }
    );

    if (res.status === 202 || res.ok) {
      form.hidden = true;
      if (successEl) successEl.hidden = false;
    } else {
      throw new Error(`Klaviyo error ${res.status}`);
    }
  } catch (err) {
    console.error('Restock notify failed:', err);
    if (errorEl) errorEl.hidden = false;
    submitBtn.disabled = false;
  }
});
